import { render, staticRenderFns } from "./AppSale.vue?vue&type=template&id=0d52305b&scoped=true&"
import script from "./AppSale.vue?vue&type=script&lang=js&"
export * from "./AppSale.vue?vue&type=script&lang=js&"
import style0 from "./AppSale.vue?vue&type=style&index=0&id=0d52305b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52305b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
